export const cssGreen = 'font-size: 1.5em; font-weight: bold; color: #00ff00; background-color: #383838;';
export const cssRed = 'font-size: 1.5em; font-weight: bold; color: #ff0000; background-color: #383838;';
export const cssBlue = 'font-size: 1.5em; font-weight: bold; color: #007fff; background-color: #383838;';
